import { useMemo } from "react";
import { useUserCollections } from "queries";

interface IUseUserCollectionsDataProps {
  userName: string;
  isRefetch: boolean;
}

export const useUserCollectionsData = (
  { userName, isRefetch }: IUseUserCollectionsDataProps
) => {
  const {
    data,
    isError,
    isLoading,
    hasNextPage,
    fetchNextPage
  } = useUserCollections({
    userName,
    isRefetch
  });

  const items = useMemo(() => {
    if (!data) {
      return [];
    }

    const fetchedItems = data.pages.map((page) => page.collections).flat();
    return fetchedItems;
  }, [data]);

  return {
    items,
    isError,
    isLoading,
    hasNextPage,
    fetchNextPage
  };
};
